import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ApiServices from "Api/ApiFactory"
import { AddItemToFavoriteListCommand, RemoveItemFromFavoriteListCommand, FavoriteList, RemoveItemFromAllFavoriteListsCommand } from "Api/CoreApi";
import store from "Store/index";
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListMixin from 'Mixins/OrderingListMixin';
import { mixins } from 'vue-class-component';

@Component({
    template: "#favorite-item-template"
})
export default class FavoriteItemComponent  extends mixins(BaseComponent, OrderingListMixin) {
    @Prop()
    public productKey: string;
    
    public loaded: boolean = true;
    
    // The parent favorite list component
    public favoriteListMenuComponent: any = null;
    
    confirm_delete : HTMLElement;
    
    // public showFavoriteIcon: boolean = false;
    
    async created() {
        this.setLoading();
        await store.dispatch.favoriteList.loadFavoriteLists(false);
        this.setLoaded();
        
        this.confirm_delete = document.getElementById('favoritelistitem_confirm_delete_on_all');
    }
    
    async mounted(){
        this.favoriteListMenuComponent = document.getElementById('basic_favoritelist');
    }
    
    get isYourSortiment(): boolean{
        return this.scopeIsOrderingList && !this.scopeIsFavoriteList;
    }
    
    get showFavoriteIcon(): boolean {
        //hack to trigger re-rendering of component
        var test= store.state.favoriteList.detectChanges;
        if(this.favoriteLists && this.favoriteLists.has(this.productKey)) 
        return this.favoriteLists.get(this.productKey).favoriteListIds.length > 0;
        return false;
    }
    
    get favoriteLists(){
        return store.getters.favoriteList.productMapToFavoriteLists;
    }
    
    // @Watch("favoriteLists")
    // async onFavoriteListChanged(){
    //     if(this.favoriteLists && this.favoriteLists.has(this.productKey)) 
    //     this.showFavoriteIcon = this.favoriteLists.get(this.productKey).favoriteListIds.length > 0;
    //     else
    //     this.showFavoriteIcon = false;
    // }
    
    
    //toogle menu
    
    
    async removeProduct(event:any)
    {
        const msg = this.confirm_delete.innerHTML.replace('{0}', this.productKey.replace('-at-SHOP1',''));
        if(confirm(msg)){
            await store.dispatch.favoriteList.removeAllItemsFromFavoriteLists(new RemoveItemFromAllFavoriteListsCommand({
                productKey : this.productKey
            }));
        }
    }
    
    toggleFavoriteListMenu(event: any) {
        // favoriteList.state.activeFavoriteLists = favoriteList.state.favoriteListsOnItem[this.productId];
        // favoriteList.state.activeFavoriteList = <ProductKey>{ Id: this.productId, LanguageId: this.languageId, VariantId: this.variantId };
        
        // if (favoriteList.state.favoriteListActive) {
        //     favoriteList.setFavoriteListInactive();
        
        // } else {
        //     favoriteList.setFavoriteListActive();
        // }
        store.dispatch.favoriteList.toggleFavoriteListMenu({productKey: this.productKey});
        
        event.currentTarget.parentNode.appendChild(this.favoriteListMenuComponent);
    }
    
}

Vue.component('favorite-item', FavoriteItemComponent);
